import axios from 'axios'

axios.defaults.baseURL = process.env.FAQ_SERVER

/**
 * Sends the given payload to the faq server to get the CAIC response
 * @param {string} id the key of the config
 * @param {Object} data the payload to send
 * @returns {Object} the CAIC response
 */
export const sendRequest = async (id, data) => {
    try {
        const response = await axios({
            method: 'post',
            data,
            url: `/faq/${id}`
        })

        return response.data
    } catch (error) {
        console.error(error.message)
    }
}

/**
 * Gets the faq configuration from the faq server
 * @param {string} id
 * @param {boolean} isPreviewMode Preview mode doesn't use cache
 * @returns {Object} the faq configuration
 */
export const getConfig = async (id, isPreviewMode) => {
    try {
        const response = await axios({
            method: 'get',
            url: `${isPreviewMode ? 'preview' : ''}/faq/${id}`
        })

        return response.data
    } catch (error) {
        console.error(error.message)
    }
}
